//所有有关用户信息的网络请求
import http from '../utils/http'
//homeFreeGift列表
export function giftList(params){
    return http({
      url:`/review/gift`,
      method:'get',
      params:params,

    })
}
//homeFreeGift 新建
export function addGift(data){
  return http({
    url:`/review/gift`,
    method:'post',
    data,

  })
}
//homeFreeGift 修改
export function editGift({id,data}){
  return http({
    url:`/review/gift/${id}`,
    method:'put',
    data,
  })
}
//homeFreeGift 图片上传
export function giftUploadPictures(params){
  return http({
    url:`/review/gift/images`,
    method:'post',
    data:params,

  })
}
//homeFreeGift 删除图片
export function giftDeletePictures(data){
  return http({
    url:`/review/gift/images/`,
    data,
    method:'delete',
  })
}